import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Cropper from 'react-easy-crop';
import './styles.css';
// import { croppedImageToReducer } from '../../actions/DataManagementActions';

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

class ImageUpload extends React.Component {
  state = {
    imageSrc: null,
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 4 / 3
  };

  onCropChange = crop => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    console.log(croppedArea, croppedAreaPixels);
  };

  onZoomChange = zoom => {
    this.setState({ zoom });
  };

  onFileChange = async e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageDataUrl = await readFile(file);
      this.props.onchangeText(file, this.props.column, imageDataUrl);
    }
  };

  render() {
    return (
      <div className="App upload-btn-wrapper">
        <input type="file" onChange={this.onFileChange} style={{ width: '100%' }} />
        {this.props.image && (
          <img src={this.props.image} width={'auto'} height={this.props.height || 200} style={{ padding: 15 }} />
        )}
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   croppedImage: state.animalsReducer.croppedImage,
//   croppedImageType: state.animalsReducer.croppedImageType
// });
function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(ImageUpload);



// WEBPACK FOOTER //
// ./screens/ImageUpload/ImageUpload.js